"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENV_CONFIGS = exports.BC_HOSTNAMES = exports.BIM360_EMEA_HOSTNAMES = exports.BIM360_HOSTNAMES = exports.EMEA_HOSTNAMES = exports.HOSTNAMES = exports.ENV_CONFIG_KEYS = exports.ENVS = exports.PLATFORMS = exports.REGIONS = void 0;
exports.REGIONS = {
    EMEA: 'EMEA',
    US: 'US',
};
exports.PLATFORMS = {
    ACC: 'acc',
    BIM360: 'bim360',
};
exports.ENVS = {
    QA: 'QA',
    STAGING: 'STAGING',
    PRODUCTION: 'PRODUCTION',
};
exports.ENV_CONFIG_KEYS = {
    ADMIN_URL: 'ADMIN_URL',
    ADMIN_V1_URL: 'ADMIN_V1_URL',
    B360_LOGIN_URL: 'B360_LOGIN_URL',
    LOGIN_URL: 'LOGIN_URL',
    DOCS_API_V1: 'DOCS_API_V1',
    ADMIN_API: 'ADMIN_API',
    ADMIN_CONSTRUCTION_API: 'ADMIN_CONSTRUCTION_API',
    OXYGEN_URL: 'OXYGEN_URL',
    RELATIONSHIP_SERVICE_URL: 'RELATIONSHIP_SERVICE_URL',
    APIGEE_URL: 'APIGEE_URL',
    ACC_HOSTNAME: 'ACC_HOSTNAME',
    REPORTS_V2_URL: 'REPORTS_V2_URL',
    FORMS_API_URL: 'FORMS_API_URL',
};
exports.HOSTNAMES = (_a = {},
    _a[exports.ENVS.QA] = 'https://acc-qa.autodesk.com',
    _a[exports.ENVS.STAGING] = 'https://acc-staging.autodesk.com',
    _a[exports.ENVS.PRODUCTION] = 'https://acc.autodesk.com',
    _a);
exports.EMEA_HOSTNAMES = (_b = {},
    _b[exports.ENVS.QA] = 'https://acc-qa.autodesk.com',
    _b[exports.ENVS.STAGING] = 'https://acc-staging.autodesk.com',
    _b[exports.ENVS.PRODUCTION] = 'https://acc.autodesk.eu',
    _b);
exports.BIM360_HOSTNAMES = (_c = {},
    _c[exports.ENVS.QA] = 'b360-qa.autodesk.com',
    _c[exports.ENVS.STAGING] = 'b360-staging.autodesk.com',
    _c[exports.ENVS.PRODUCTION] = 'b360.autodesk.com',
    _c);
exports.BIM360_EMEA_HOSTNAMES = (_d = {},
    _d[exports.ENVS.QA] = '',
    _d[exports.ENVS.STAGING] = 'b360-staging.eu.autodesk.com',
    _d[exports.ENVS.PRODUCTION] = 'b360.eu.autodesk.com',
    _d);
exports.BC_HOSTNAMES = (_e = {},
    _e[exports.ENVS.QA] = '',
    _e[exports.ENVS.STAGING] = 'https://app-stage.buildingconnected.com/',
    _e[exports.ENVS.PRODUCTION] = 'https://app.buildingconnected.com/',
    _e);
var APIGEE_URL = (_f = {},
    _f[exports.ENVS.QA] = 'https://developer-stg.api.autodesk.com',
    _f[exports.ENVS.STAGING] = 'https://developer-stg.api.autodesk.com',
    _f[exports.ENVS.PRODUCTION] = 'https://developer.api.autodesk.com',
    _f);
var BIM360_ADMIN_URL = (_g = {},
    _g[exports.ENVS.QA] = "".concat(APIGEE_URL[exports.ENVS.QA], "/ea-api-qa"),
    _g[exports.ENVS.STAGING] = "".concat(APIGEE_URL[exports.ENVS.STAGING], "/ea-api"),
    _g[exports.ENVS.PRODUCTION] = "".concat(APIGEE_URL[exports.ENVS.PRODUCTION], "/ea-api"),
    _g);
var BIM360_ADMIN_V1_URL = (_h = {},
    _h[exports.ENVS.QA] = "".concat(BIM360_ADMIN_URL[exports.ENVS.QA], "/v1"),
    _h[exports.ENVS.STAGING] = "".concat(BIM360_ADMIN_URL[exports.ENVS.STAGING], "/v1"),
    _h[exports.ENVS.PRODUCTION] = "".concat(BIM360_ADMIN_URL[exports.ENVS.PRODUCTION], "/v1"),
    _h);
var ADMIN_API_URL = (_j = {},
    _j[exports.ENVS.QA] = "".concat(APIGEE_URL[exports.ENVS.QA], "/bim360-qa/admin"),
    _j[exports.ENVS.STAGING] = "".concat(APIGEE_URL[exports.ENVS.STAGING], "/bim360/admin"),
    _j[exports.ENVS.PRODUCTION] = "".concat(APIGEE_URL[exports.ENVS.PRODUCTION], "/bim360/admin"),
    _j);
var ADMIN_CONSTRUCTION_API_URL = (_k = {},
    _k[exports.ENVS.QA] = "".concat(APIGEE_URL[exports.ENVS.QA], "/construction-qa/admin"),
    _k[exports.ENVS.STAGING] = "".concat(APIGEE_URL[exports.ENVS.STAGING], "/construction/admin"),
    _k[exports.ENVS.PRODUCTION] = "".concat(APIGEE_URL[exports.ENVS.PRODUCTION], "/construction/admin"),
    _k);
var DOCS_API_V1_URL = (_l = {},
    _l[exports.ENVS.QA] = "".concat(APIGEE_URL[exports.ENVS.QA], "/ea-dm-qa/v1"),
    _l[exports.ENVS.STAGING] = "".concat(APIGEE_URL[exports.ENVS.STAGING], "/dm-staging/v1"),
    _l[exports.ENVS.PRODUCTION] = "".concat(APIGEE_URL[exports.ENVS.PRODUCTION], "/dm/v1"),
    _l);
var RELATIONSHIP_API_URL = (_m = {},
    _m[exports.ENVS.QA] = "".concat(APIGEE_URL[exports.ENVS.QA], "/bim360/relationship-dev"),
    _m[exports.ENVS.STAGING] = "".concat(APIGEE_URL[exports.ENVS.STAGING], "/bim360/relationship"),
    _m[exports.ENVS.PRODUCTION] = "".concat(APIGEE_URL[exports.ENVS.PRODUCTION], "/bim360/relationship"),
    _m);
var OXYGEN_URL = (_o = {},
    _o[exports.ENVS.QA] = 'https://accounts-staging.autodesk.com',
    _o[exports.ENVS.STAGING] = 'https://accounts-staging.autodesk.com',
    _o[exports.ENVS.PRODUCTION] = 'https://accounts.autodesk.com',
    _o);
var B360_LOGIN_URL = (_p = {},
    _p[exports.ENVS.QA] = 'https://login.b360-qa.autodesk.com',
    _p[exports.ENVS.STAGING] = 'https://login.b360-staging.autodesk.com',
    _p[exports.ENVS.PRODUCTION] = 'https://login.b360.autodesk.com',
    _p);
var B360_EMEA_LOGIN_URL = (_q = {},
    _q[exports.ENVS.QA] = 'https://login.b360-qa.autodesk.com',
    _q[exports.ENVS.STAGING] = 'https://login.b360-staging.eu.autodesk.com',
    _q[exports.ENVS.PRODUCTION] = 'https://login.b360.eu.autodesk.com',
    _q);
var LOGIN_URL = (_r = {},
    _r[exports.ENVS.QA] = 'https://login.acc-qa.autodesk.com',
    _r[exports.ENVS.STAGING] = 'https://login.acc-staging.autodesk.com',
    _r[exports.ENVS.PRODUCTION] = 'https://login.acc.autodesk.com',
    _r);
var EMEA_LOGIN_URL = (_s = {},
    _s[exports.ENVS.QA] = 'https://login.acc-qa.autodesk.com',
    _s[exports.ENVS.STAGING] = 'https://login.acc-staging.autodesk.com',
    _s[exports.ENVS.PRODUCTION] = 'https://login.acc.autodesk.eu',
    _s);
var REPORTS_V2_URL = (_t = {},
    _t[exports.ENVS.QA] = "".concat(APIGEE_URL[exports.ENVS.QA], "/reports-qa/v2"),
    _t[exports.ENVS.STAGING] = "".concat(APIGEE_URL[exports.ENVS.STAGING], "/reports/v2"),
    _t[exports.ENVS.PRODUCTION] = "".concat(APIGEE_URL[exports.ENVS.PRODUCTION], "/reports/v2"),
    _t);
var FORMS_API_URL = (_u = {},
    _u[exports.ENVS.QA] = "".concat(APIGEE_URL[exports.ENVS.QA], "/construction/forms-qa"),
    _u[exports.ENVS.STAGING] = "".concat(APIGEE_URL[exports.ENVS.STAGING], "/construction/forms"),
    _u[exports.ENVS.PRODUCTION] = "".concat(APIGEE_URL[exports.ENVS.PRODUCTION], "/construction/forms"),
    _u);
var getEnvConfig = function (env) {
    var _a;
    return (_a = {},
        _a[exports.ENV_CONFIG_KEYS.LOGIN_URL] = LOGIN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.B360_LOGIN_URL] = B360_LOGIN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.DOCS_API_V1] = DOCS_API_V1_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_API] = ADMIN_API_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_CONSTRUCTION_API] = ADMIN_CONSTRUCTION_API_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_URL] = BIM360_ADMIN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_V1_URL] = BIM360_ADMIN_V1_URL[env],
        _a[exports.ENV_CONFIG_KEYS.RELATIONSHIP_SERVICE_URL] = RELATIONSHIP_API_URL[env],
        _a[exports.ENV_CONFIG_KEYS.OXYGEN_URL] = OXYGEN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.APIGEE_URL] = APIGEE_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ACC_HOSTNAME] = exports.HOSTNAMES[env],
        _a[exports.ENV_CONFIG_KEYS.REPORTS_V2_URL] = REPORTS_V2_URL[env],
        _a[exports.ENV_CONFIG_KEYS.FORMS_API_URL] = FORMS_API_URL[env],
        _a);
};
var getEmeaEnvConfig = function (env) {
    var _a;
    return (_a = {},
        _a[exports.ENV_CONFIG_KEYS.LOGIN_URL] = EMEA_LOGIN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.B360_LOGIN_URL] = B360_EMEA_LOGIN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.DOCS_API_V1] = DOCS_API_V1_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_API] = ADMIN_API_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_CONSTRUCTION_API] = ADMIN_CONSTRUCTION_API_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_URL] = BIM360_ADMIN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ADMIN_V1_URL] = BIM360_ADMIN_V1_URL[env],
        _a[exports.ENV_CONFIG_KEYS.RELATIONSHIP_SERVICE_URL] = RELATIONSHIP_API_URL[env],
        _a[exports.ENV_CONFIG_KEYS.OXYGEN_URL] = OXYGEN_URL[env],
        _a[exports.ENV_CONFIG_KEYS.APIGEE_URL] = APIGEE_URL[env],
        _a[exports.ENV_CONFIG_KEYS.ACC_HOSTNAME] = exports.EMEA_HOSTNAMES[env],
        _a[exports.ENV_CONFIG_KEYS.REPORTS_V2_URL] = REPORTS_V2_URL[env],
        _a[exports.ENV_CONFIG_KEYS.FORMS_API_URL] = FORMS_API_URL[env],
        _a);
};
var US_CONFIG = (_v = {},
    _v[exports.ENVS.QA] = getEnvConfig(exports.ENVS.QA),
    _v[exports.ENVS.STAGING] = getEnvConfig(exports.ENVS.STAGING),
    _v[exports.ENVS.PRODUCTION] = getEnvConfig(exports.ENVS.PRODUCTION),
    _v);
var EMEA_CONFIG = (_w = {},
    _w[exports.ENVS.QA] = getEmeaEnvConfig(exports.ENVS.QA),
    _w[exports.ENVS.STAGING] = getEmeaEnvConfig(exports.ENVS.STAGING),
    _w[exports.ENVS.PRODUCTION] = getEmeaEnvConfig(exports.ENVS.PRODUCTION),
    _w);
exports.ENV_CONFIGS = (_x = {},
    _x[exports.REGIONS.US] = US_CONFIG,
    _x[exports.REGIONS.EMEA] = EMEA_CONFIG,
    _x);
